import { useTranslation } from 'react-i18next';

import { ReportDimensionResponse, ReportDimensionSourceDTO } from '../types/report-dimension';

interface DimensionLabelProps {
  dimension: ReportDimensionResponse;
}

/**
 * A selected dimension's name. Custom attributes are named by each organization and can collide
 * with built-in fields, so they're prefixed with what they describe ("Team member · English level").
 */
export const DimensionLabel = ({ dimension }: DimensionLabelProps) => {
  const { t } = useTranslation('authenticated.reports');

  if (dimension.source !== ReportDimensionSourceDTO.CUSTOM_ATTRIBUTE) {
    return <>{dimension.label}</>;
  }

  return (
    <>
      <span className="text-muted-foreground">
        {t(`dimensionPicker.entity.${dimension.entity}`)}
        {t('common.separator')}
      </span>
      {dimension.label}
    </>
  );
};
